<template>
  <a-card>
    <h1>发布作品</h1>
    <a-divider></a-divider>

    <a-input
      v-model="workInfo.workName"
      size="large"
      addonBefore="作品标题"
      placeholder="请输入作品标题"
    ></a-input>
    <br /><br />
    <JMavonEditor v-model="workInfo.content"/>
    <a-divider></a-divider>
    <div class="work-opt">
      <a-row>
        <!-- <a-col :span="6">
          <a-radio-group v-model="workInfo.canReplay">
            <a-radio-button :value="1"> 可回复 </a-radio-button>
            <a-radio-button :value="0"> 禁止回复 </a-radio-button>
          </a-radio-group>
        </a-col> -->
        <!-- <a-col :span="6">
          <a-radio-group v-model="workInfo.showLimit">
            <a-radio-button :value="0"> 公开 </a-radio-button>
            <a-radio-button :value="1"> 本校 </a-radio-button>
          </a-radio-group>
        </a-col> -->
      </a-row>
    </div>
    <span class="submit-btn" v-if="!token">请先登录</span>
    <span class="submit-btn" v-else @click="submit">{{workId?'修改':'发布'}}</span>
  </a-card>
</template>

<script>
import Vue from "vue";
import JMavonEditor from "@/components/jeecg/JMavonEditor"
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { getAction, postAction } from "@/api/manage";
export default {
  components:{
    JMavonEditor
  },
  data() {
    return {
      token: "",
      workId: "",
      workInfo: {
        showLimit: 0, //展示限制
        canReplay: 1, //是否可回复
      },
    };
  },
  created() {
    this.token = Vue.ls.get(ACCESS_TOKEN);
    if (this.$route.query.workId) {
      this.workId = this.$route.query.workId;
      this.getWorkInfo(this.workId)
    }
  },
  methods: {
    submit() {
      if (this.workInfo.workName == "" || this.workInfo.workName == null) {
        this.$message.error("请填写标题");
        return;
      }
      if (this.workInfo.content == "" || this.workInfo.content == null) {
        this.$message.error("请填写内容");
        return;
      }
      let workData = {
        id: this.workId,
        codeType: 0,
      }
      Object.assign(workData, this.workInfo)
      
      postAction("/teaching/teachingWork/submit", workData).then((res) => {
        if(res.success){
            this.workId = res.result.id
            this.$message.success(res.message);
        }else{
            this.$message.error(res.message);
        }
      });
    },
    getWorkInfo(workId) {
      getAction("/teaching/teachingWork/studentWorkInfo?workId=" + workId).then(
        (res) => {
          if (res.success) {
            this.workInfo = res.result;
          }else{
            this.$message.error(res.message);
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.submit-btn {
  margin: 30px auto;
  color: white;
  display: block;
  width: 144px;
  height: 50px;
  line-height: 50px;
  border-radius: 50px;
  text-align: center;
  cursor: pointer;
  font-size: 20px;
  background: rgba(245, 154, 35, 1);
  &:first-child {
    margin-right: 60px;
  }
}
</style>